export interface IAppConfig {
  api: { url: string };
}

const developmentApiUrl =
  process.env.REACT_APP_FORMS_API_URL || "https://deva.bponline.dev";

export const appConfig =
  process.env.NODE_ENV !== "development"
    ? ((window as any).appConfig as IAppConfig)
    : { api: { url: developmentApiUrl } };
